// @owners { team: patients }
export const SUPPORT_CASES_WITH_UNREAD_MESSAGES = 'SUPPORT_CASES_WITH_UNREAD_MESSAGES';
export function updateSupportCaseWithUnreadMessages(supportCaseWithUnreadMessages: Set<number>) {
  return {
    type: SUPPORT_CASES_WITH_UNREAD_MESSAGES,
    payload: supportCaseWithUnreadMessages,
  } as const;
}
